<template>
  <div class="revatech-layout">
    <announcement-banner />
    <app-header />
    <router-view />
    <app-footer />
  </div>
</template>

<script>
import Header from './components/shared/Header';
import Footer from './components/shared/Footer';
import AnnouncementBanner from './components/AnnouncementBanner';

export default {
  components: {
    'announcement-banner': AnnouncementBanner,
    'app-header': Header,
    'app-footer': Footer
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = `REVATECH - ${this.$t(`page.title.${to.name}`)}`;
      }
    },
    '$i18n.locale': {
      immediate: true,
      handler() {
        document.title = `REVATECH - ${this.$t(`page.title.${this.$route.name}`)}`;
      }
    }
  }

};
</script>
